import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const LoadMemberNonPublicFieldsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LoadMemberNonPublicFields"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"member"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"nonPublic"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"avatarHash"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}},{"kind":"Field","name":{"kind":"Name","value":"initials"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}}]}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions =  {"context":{"operationName":"LoadMemberNonPublicFields","document":LoadMemberNonPublicFieldsDocument}}
export type LoadMemberNonPublicFieldsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type LoadMemberNonPublicFieldsQuery = (
  { __typename: 'Query' }
  & { member?: Types.Maybe<(
    { __typename: 'Member' }
    & Pick<Types.Member, 'id' | 'avatarUrl' | 'fullName' | 'initials'>
    & { nonPublic?: Types.Maybe<(
      { __typename: 'Member_NonPublic' }
      & Pick<Types.Member_NonPublic, 'avatarHash' | 'avatarUrl' | 'initials' | 'fullName'>
    )> }
  )> }
);




/**
 * __useLoadMemberNonPublicFieldsQuery__
 *
 * To run a query within a React component, call `useLoadMemberNonPublicFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLoadMemberNonPublicFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLoadMemberNonPublicFieldsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLoadMemberNonPublicFieldsQuery(baseOptions: Apollo.QueryHookOptions<LoadMemberNonPublicFieldsQuery, LoadMemberNonPublicFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LoadMemberNonPublicFieldsQuery, LoadMemberNonPublicFieldsQueryVariables>(LoadMemberNonPublicFieldsDocument, options);
      }
export function useLoadMemberNonPublicFieldsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LoadMemberNonPublicFieldsQuery, LoadMemberNonPublicFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LoadMemberNonPublicFieldsQuery, LoadMemberNonPublicFieldsQueryVariables>(LoadMemberNonPublicFieldsDocument, options);
        }
export type LoadMemberNonPublicFieldsQueryHookResult = ReturnType<typeof useLoadMemberNonPublicFieldsQuery>;
export type LoadMemberNonPublicFieldsLazyQueryHookResult = ReturnType<typeof useLoadMemberNonPublicFieldsLazyQuery>;
export type LoadMemberNonPublicFieldsQueryResult = Apollo.QueryResult<LoadMemberNonPublicFieldsQuery, LoadMemberNonPublicFieldsQueryVariables>;